import { makeApiCall } from '../_common/api.utils';
import { API_URL, FIN_API_URL } from '../const';
/*************** Create Company Start ******************/
export const companyDetailsAdd = (addData: any) => {
	const data = {
		CreateCompanyDetailsDataToken: addData,
	};
	const url = `${API_URL}createCompany`;
	return makeApiCall(url, data);
};
/*************** Create Company End ******************/

/*************** Get All Company List Start ******************/
export const companyGetList = (listData: any) => {
	const data = {
		GetCompanyListDataToken: listData,
	};
	const url = `${API_URL}getAllCompanyList`;
	return makeApiCall(url, data);
};
/*************** Get All Company List End ******************/

/*************** Fetch Company Details Start ******************/
export const companyDetailsGet = (listData: any) => {
	const data = {
		FetchCompanyDetailsDataToken: listData,
	};
	const url = `${API_URL}fetchCompanyDetails`;
	return makeApiCall(url, data);
};
/*************** Fetch Company Details End ******************/

/*************** Update Company Details Start ******************/
export const companyDetailsUpdate = (listData: any) => {
	const data = {
		UpdateCompanyDetailsDataToken: listData,
	};
	const url = `${API_URL}updateCompanyDetails`;
	return makeApiCall(url, data);
};
/*************** Update Company Details End ******************/

/*************** Delete Company Details Start ******************/
export const companyDetailsDelete = (listData: any) => {
	const data = {
		DeleteCompanyDetailsToken: listData,
	};
	const url = `${API_URL}deleteCompany`;
	return makeApiCall(url, data);
};
/*************** Delete Company Details End ******************/

// FINANCE COMPANY

/*************** Create Company For Finance Start ******************/
export const createCompany = (listData: any) => {
	const data = {
		CreateCompanyToken: listData,
	};
	const url = `${FIN_API_URL}createFinanceCompany`;
	return makeApiCall(url, data);
};
/*************** Create Company For Finance End ******************/

/*************** Update Company For Finance Start ******************/
export const updateCompany = (listData: any) => {
	const data = {
		UpdateCompanyToken: listData,
	};
	const url = `${FIN_API_URL}updateFinanceCompany`;
	return makeApiCall(url, data);
};
/*************** Update Company For Finance End ******************/

/*************** Delete Company For Finance Start ******************/
export const deleteCompany = (listData: any) => {
	const data = {
		DeleteCompanyToken: listData,
	};
	const url = `${FIN_API_URL}deleteFinanceCompany`;
	return makeApiCall(url, data);
};
/*************** Delete Company For Finance End ******************/

/*************** Create Instance Company For Start ******************/
export const instanceDetailsAdd = (listData: any) => {
	const data = {
		CreateInstanceDBToken: listData,
	};
	const url = `${API_URL}instanceCreateCompany`;
	return makeApiCall(url, data);
};
/***************  Create Instance Company For End ******************/

/*************** Create Alter table Start ******************/
export const AlterTableCreate = (listData: any) => {
	const data = {
		AlterQueryDBToken: listData,
	};
	const url = `${API_URL}instanceAlterDBCompany`;
	return makeApiCall(url, data);
};
/***************  Create Alter table End ******************/

/*************** Fetch Exist Data Start ******************/
export const fetchExistData = (listData: any) => {
	const data = {
		ExistInfoToken: listData,
	};
	const url = `${API_URL}existCompanyDetails`;
	return makeApiCall(url, data);
};
/*************** Fetch Exist Data End ******************/
